import { Observable } from "rxjs";
import { EntityId } from ".";

// abstract class, not interface to make it work nice with "provides" in app.module :-)
// not sure whether this is "good", though.
export abstract class AbstractUserService {
  public abstract saveUserRoles(
    userId: EntityId,
    roles: IRoleEdit[]
  ): Observable<boolean>;
  public abstract saveRoles(roles: IRoleAdmin[]): Observable<boolean>;
  public abstract getCurrentUser(): Observable<IUser>;
  public abstract getUser(userId: UserId): Observable<IUser>;
  public abstract getUserRole(userId: UserId): Observable<IRoleEdit[]>;
  public abstract getRoles(): Observable<IRoleAdmin[]>;
  public abstract getUsers(login: string[]): Observable<IUser[]>;
  public abstract getAllUsers(): Observable<IUser[]>;
  public abstract getLanguages(): Observable<IUserLanguage>;
  public abstract setPreferredLanguage(lang: string): Observable<boolean>;
}

export type UserId = EntityId;

export interface Role {
  name: string;
  abilities: Ability[];
}

export interface IRoleAdmin {
  id: number;
  name: string;
  subjects: ISubject[];
}

export interface IRoleEdit {
  checked: boolean;
  name: string;
  id: number;
}

export interface Ability {
  subject: string;
  action: string;
}

export interface ISubject {
  name: string;
  actions: IAction[];
}

export interface IAction {
  name: string;
  checked: boolean;
}
export interface IUser extends IUserLanguage, IAbstractPersona {
  imageSrc: string;
  roles: Role[];
}

export interface IAbstractPersona {
  id: UserId;
  displayName: string;
  login: string;
  isAadGuest: boolean;
  email?: string;
}

export interface IUserLanguage {
  languages: string;
  preferredLanguage: string;
}
